import Command from '@ckeditor/ckeditor5-core/src/command';

// convert selected text to annotation
class insertAnchorCommand extends Command {
  execute({ name, id }) {
    const editor = this.editor;
    const selection = editor.model.document.selection;
    const selectedContent = editor.model.getSelectedContent(selection);
    const selectedContentHtml = editor.data.stringify(selectedContent);

    const html = `<a class="hrbr-highlight" data-anchorid="${id}" name="${name}">${
      selectedContentHtml || '{⚓️}'
    }</p>`;
    const viewFragment = editor.data.processor.toView(html);
    const modelFragment = editor.data.toModel(viewFragment);
    editor.model.insertContent(modelFragment);
  }

  refresh() {
    const model = this.editor.model;
    const selection = model.document.selection;

    const isAllowed = model.schema.checkChild(selection.focus.parent, 'annotation');

    this.isEnabled = true;
  }
}

export default insertAnchorCommand;
